import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=36ea3c15&scoped=true&"
import script from "./LockIcon.vue?vue&type=script&lang=js&"
export * from "./LockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea3c15",
  null
  
)

export default component.exports